/** 화면 테마 — 회원 전용 설정. DB(users.theme)에 저장되어 기기·브라우저가 바뀌어도 유지된다 */
export const THEMES = ['system', 'light', 'dark'] as const;
export type ThemeName = (typeof THEMES)[number];

export const THEME_LABELS: Record<ThemeName, { ko: string }> = {
  system: { ko: '시스템' },
  light: { ko: '라이트' },
  dark: { ko: '다크' },
};

/** 기본값 — 비회원·미설정 회원 (현재 디자인 기준) */
export const DEFAULT_THEME: ThemeName = 'dark';

/**
 * 마지막으로 적용한 테마를 담아두는 브라우저 키.
 *
 * ⚠️ 저장소가 아니라 **캐시**다. 진실의 원천은 여전히 DB(users.theme)이고,
 * 이 값은 첫 페인트를 맞추는 용도로만 쓴다. 지워져도 로그인하면 DB 값이 다시 덮어쓴다.
 *
 * 왜 필요한가: 테마는 `/api/auth/me` 응답이 와야 알 수 있는데, 그 전까지 문서에는
 * data-theme이 없어 기본(다크)으로 그려진다. 라이트를 쓰는 회원은 새로고침할 때마다
 * 다크가 번쩍였다가 라이트로 돌아온다. index.html의 부트 스크립트가 이 값을 읽어
 * 첫 페인트 전에 적용한다.
 */
export const THEME_STORAGE_KEY = 'tw_theme';
